// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39I7u","textarea":"styles_textarea__1pPpA"};